// extracted by mini-css-extract-plugin
export default {"large":"only screen and (min-width: 992px)","oppositeGenderLink":"u3q4l a8cCT pZTkT","chevron":"ZJSMP","link":"obbpB x25tu a8cCT"};